import { Box, Link, Typography, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { useLocation } from 'react-router-dom';

import THEME from '../../constants/theme';

/**
 * Footer component with company information and copyright
 *
 * @returns {React.Component} FooterComponent
 */
const FooterComponent = () => {
  const location = useLocation();

  // Don't render footer on home page (controlled by Layout component)
  if (location.pathname === '/') {
    return null;
  }

  return (
    <Box component='footer' sx={{ width: '100%', overflowX: 'hidden', position: 'relative', zIndex: 5, py: { xs: 4, md: 4 }, px: { xs: 2, md: 0 }}}>
      <Box sx={{ width: '100%', position: 'relative' }}>
        {/* Decorative top border */}
        <Box sx={{ height: 4, width: '100%', background: 'linear-gradient(90deg, var(--primary-purple), rgba(169,64,255,0.12))', mb: 2 }} />
        {/* Address and copyright content */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: { xs: 'center', md: 'flex-start' },
            alignItems: { xs: 'center', md: 'flex-start' },
            textAlign: { xs: 'center', md: 'left' },
            maxWidth: { xs: '100%', sm: '60%' },
            gap: { xs: 2, md: 1.5 }
          }}
        >
          <Box>
            <Typography
              variant='body2'
              sx={{
                color: THEME.COLORS.NEUTRAL_GRAY_DARK,
                fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.SECONDARY,
                fontSize: '0.9rem',
                lineHeight: 1.5
              }}
            >
              Capital Office, 124 City Road, London, EC1V 2NX, England
            </Typography>
          </Box>

          <Typography
            variant='caption'
            sx={{
              color: THEME.COLORS.NEUTRAL_GRAY_DARK,
              opacity: 0.7,
              fontFamily: THEME.TYPOGRAPHY.FONT_FAMILY.SECONDARY,
              fontSize: '0.75rem'
            }}
          >
            COPYRIGHT © 2025 | Spinnaker Algo Systems Limited | ALL RIGHTS RESERVED
          </Typography>
        </Box>

        {/* LinkedIn icon */}
        <IconButton
          component={Link}
          href='https://www.linkedin.com/company/spinnaker-algo-ltd/'
          target='_blank'
          rel='noopener noreferrer'
          aria-label='LinkedIn'
          sx={{
            color: THEME.COLORS.PRIMARY_PURPLE,
            padding: 0.5,
            position: { xs: 'static', md: 'absolute' },
            right: { md: '5%' },
            top: { md: '50%' },
            transform: { md: 'translateY(-50%)' },
            marginTop: { xs: 3, md: 0 },
            transition: 'all 0.2s ease',
            display: 'flex',
            justifyContent: 'center',
            '&:hover': {
              opacity: 0.8,
              transform: { xs: 'scale(1.1)', md: 'translateY(-50%) scale(1.1)' }
            }
          }}
        >
          <LinkedInIcon
            sx={{
              fontSize: { xs: '28px', sm: '30px' }
            }}
          />
        </IconButton>
      </Box>
    </Box>
  );
};

export default FooterComponent;
